'use strict'

var Type = require('../type')

module.exports = Type({
  name: 'JCB',
  pattern: /^35\d{14}$/,
  eagerPattern: /^35/
})



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/creditcards-types/types/jcb.js
// module id = qTvd
// module chunks = 0